const SFX_BASE =
  "https://img.securedataimages.com/images/cams/cams2/images/emojis/sfx_files";

export const EMOJI_SFX_MAP: Record<string, string> = {
  virtual_gift_emoji_hot: `${SFX_BASE}/HOT/hotSFX.wav`,
  virtual_gift_emoji_hug: `${SFX_BASE}/HUG/hugSFX.wav`,
  virtual_gift_emoji_kiss: `${SFX_BASE}/KISS/kissSFX.wav`,
  virtual_gift_emoji_heart: `${SFX_BASE}/HEART/heartSFX.wav`,
  virtual_gift_emoji_eggplant: `${SFX_BASE}/EGGPLANT/eggplantSFX.wav`,
  virtual_gift_emoji_melons: `${SFX_BASE}/MELONS/melonsSFX.wav`,
  virtual_gift_emoji_banana2: `${SFX_BASE}/BANANA/bananaSFX.wav`,
  virtual_gift_emoji_lick: `${SFX_BASE}/LICKING/lickingSFX.wav`,
  virtual_gift_emoji_peach: `${SFX_BASE}/PEACH/peachSFX.wav`,
  virtual_gift_emoji_wolf: `${SFX_BASE}/WOLF/wolfSFX.wav`,
};

export const isEmojiGift = (giftName: string): boolean => {
  return giftName in EMOJI_SFX_MAP;
};
